import React, { useCallback } from "react";
import { useRouter } from "next/router";
import { emitUpsellNudgeAction, emitUpsellNudgeImpression, } from "@catchoftheday/analytics";
import { Box, Flex, IconOnePass, Link, Span, } from "@catchoftheday/cg-components";
import { URL_LOGIN } from "@catchoftheday/common-vendors";
import { useCustomerQuery } from "@catchoftheday/customer";
import { useIsInViewport } from "@catchoftheday/utilities";
import { OnePassCTAButton } from "../OnePassCTAButton";
import { triggerOnePassLinkingModal } from "../OnePassLinkingModal";
import { triggerOnePassUpsellModal } from "../OnePassUpsellModal";
export const OnePassCTAWidget = () => {
    const { data } = useCustomerQuery({ ssr: false });
    const { customer } = data || {};
    const { asPath } = useRouter();
    const showFreeTrial = !customer ||
        !customer.membership ||
        (!customer.club?.active &&
            !customer.membership?.linked &&
            !customer.club?.freeTrialEligible) ||
        customer.membership?.subscription?.freeTrialEligible;
    const showLogIn = !customer;
    const showOnePassLink = customer && !customer.membership?.linked;
    const showAlreadyAMember = showLogIn || showOnePassLink;
    const onMainCTAClick = useCallback(() => {
        emitUpsellNudgeAction(showFreeTrial ? "freeTrial" : "join");
        triggerOnePassUpsellModal();
    }, [showFreeTrial]);
    const onLinkButtonClick = useCallback(() => {
        emitUpsellNudgeAction("link");
        triggerOnePassLinkingModal({
            originalUrl: asPath,
        });
    }, [asPath]);
    const onLoginClick = useCallback(() => {
        emitUpsellNudgeAction("login");
    }, []);
    const trackImpression = useCallback(() => {
        emitUpsellNudgeImpression();
    }, []);
    const { ref: upsellComponent } = useIsInViewport({
        onComponentSeen: trackImpression,
    });
    return (<Box ref={upsellComponent} data-testid="OnePassCTAWidget">
      <Flex flexDirection="column" p="12px 16px" fontFamily="onePass" color="onePass.textPrimary" borderRadius="16px" borderColor="onePass.primary" borderStyle="solid" borderWidth="2px" cursor="pointer" role="button" onClick={onMainCTAClick} aria-label={showFreeTrial ? "Start free 30 day trial" : "Join OnePass today"}>
        <Flex alignItems="center" mb="6px">
          <Span fontWeight="bold" fontSize="base" lineHeight="20px" whiteSpace="nowrap">
            Get free delivery with
          </Span>
          <IconOnePass title="OnePass" aria-label="OnePass" color="onePass.primary" width="70px" height="15px" ml="3px" mb="3px"/>
        </Flex>
        <Span fontSize="12px" fontWeight="medium" lineHeight="16px">
          Join for free delivery on this item and more!{" "}
          <Span color="onePass.primary" fontWeight="bold" fontSize="inherit" textDecoration="underline" whiteSpace="nowrap">
            {showFreeTrial ? "Start free 30 day trial" : "Join OnePass today"}
          </Span>
        </Span>
      </Flex>
      {showAlreadyAMember && (<Flex justifyContent="center" mt="3px">
          <Span fontSize="12px" color="onePass.textPrimary">
            Already a member?
          </Span>
          {showLogIn ? (<Link onClick={onLoginClick} href={URL_LOGIN} pl="2px" fontSize="12px" fontWeight="bold" color="onePass.primary" textDecoration="underline">
              Log in
            </Link>) : (<OnePassCTAButton pl="2px" onClick={onLinkButtonClick}>
              Link OnePass with Catch
            </OnePassCTAButton>)}
        </Flex>)}
    </Box>);
};
